// sticky nawigacja i metka


var hh = $('.header .header--nav').height();

$(window).scroll(function () {

    hh = $('.header .header--nav').height();

    if (window.scrollY > ($('.articles').offset().top)) {
        $(".header").addClass('nav-fixed');
    } else {
        $(".header").removeClass('nav-fixed');
    }

    if (window.scrollY < document.body.offsetHeight - window.innerHeight - 200 && window.scrollY > $('.articles').offset().top) {
        $(".sticky--logo").addClass('__jsVisible');
    } else {
        $(".sticky--logo").removeClass('__jsVisible');
    }
});


// zmiana metki dla kategorii
//var $stickyLogo = $('.sticky--logo');
//
//var chageStickyLogo = function(data) {
//    if($stickyLogo.length) {
//        if($stickyLogo.attr('href') !== data.url) {
//            $stickyLogo.attr('href', data.url);
//            if (document.location.hostname !== "localhost" && document.location.hostname !== "10.10.44.3") {
//                $stickyLogo.find('iframe').attr('src', data.impression);
//            }
//
//        }
//        if($stickyLogo.find('img').attr('src') !== data.logo) {
//            $stickyLogo.find('img').animate({opacity:0},100);
//            $stickyLogo.find('img').attr('src', data.logo);
//            $stickyLogo.find('img').animate({opacity:1},200);
//        }
//    }
//};
